import { ReturnAssessmentGroupWithAssessmentsSchema } from "@redotech/redo-model/return-assessments/assessment-schemas";
import * as z from "zod/v4";

export const getAssessmentGroupList = {
  name: "getAssessmentGroupList" as const,

  input: z.null(),

  output: z.array(ReturnAssessmentGroupWithAssessmentsSchema),
};
